import React, {useState} from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {useSelector} from 'react-redux';
import {Color, globalFontStyle} from '../assets';
import Width from '../assets/Width';
import FastImage from '../common/FastImage';
import {event_about} from '../utils/images';
import FormTextLabel from './FormTextLabel';
import {globalConfigurableData, GlobalScreens} from '../utils/globalConstant';
import MarketResolution from '../screens/event/childComponents/MarketResolution';
import ListOfTrades from '../screens/portfolio/childComponents/listOfTrades';
import OrderBook from '../screens/event/childComponents/OrderBook';

const NEWFAQ = ({faqtype = 'wallet'}) => {
  const faqData = useSelector(({utilReducer}) => utilReducer?.faqsData);
  const data = faqData && faqData[faqtype] ? faqData[faqtype] : null;
  const [showFaq, setFaq] = useState(null);

  return (
    <View style={{marginTop: 12, paddingBottom: 20, paddingHorizontal: 16}}>
      <FormTextLabel
        labelStyles={{
          ...globalFontStyle.appFontTitle,
          textAlign: 'left',
          color: globalConfigurableData.primaryTextColor1,
          paddingTop: 10,
        }}
        label={'FAQ'}
      />
      {data && (
        <View style={{marginTop: 0}}>
          {data?.map((qaItem, i) => {
            return (
              <View style={styles.eventDetailsBox}>
                <TouchableOpacity
                  onPress={() => {
                    if (showFaq === i) {
                      setFaq(null);
                    } else {
                      setFaq(i);
                    }
                  }}>
                  <View style={styles.eventDetailTitle}>
                    <View style={{flex: 1}}>
                      <FormTextLabel
                        label={qaItem?.q}
                        labelStyles={{
                          color: globalConfigurableData.primaryTextColor1,
                          ...globalFontStyle.appFontSubHeading,
                        }}
                      />
                    </View>
                    <FastImage
                      source={
                        showFaq === i
                          ? globalConfigurableData?.up_arrow()
                          : globalConfigurableData?.down_arrow()
                      }
                      style={{width: 18, height: 18}}
                    />
                  </View>
                </TouchableOpacity>
                {showFaq === i ? (
                  <Text
                    style={[
                      globalFontStyle.appFontSubText,
                      {
                        color: globalConfigurableData.secondaryTextColor1,
                        paddingBottom: 15,
                        borderTopWidth: 0.75,
                        paddingTop: 12,
                        borderColor: GlobalScreens.Event.borderColor,
                      },
                    ]}>
                    {qaItem?.a}
                  </Text>
                ) : null}
              </View>
            );
          })}
        </View>
      )}
    </View>
  );
};

export default NEWFAQ;

const styles = StyleSheet.create({
  eventDetailTitle: {
    paddingVertical: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  eventDetailsBox: {
    marginTop: 15,
    borderWidth: 0.75,
    borderColor: GlobalScreens.Event.borderColor,
    borderRadius: 8,
    paddingHorizontal: 12,
    backgroundColor: GlobalScreens.Event.cardBgColor,
  },
});
